import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

// PRODUCTION_DOMAIN — replace with the final production domain before launch.
// Currently set to a reasonable placeholder for canonical URLs and sitemap
// generation. When the founder confirms the production host, update here and
// in /public/sitemap.xml.
export const PRODUCTION_DOMAIN = "https://celestialseedsanctuary.org";

// DEFAULT_OG_IMAGE — replace with a Celestial Seed brand image (1200x630) when
// available. Currently uses a cloud-forest Unsplash image at the correct ratio.
export const DEFAULT_OG_IMAGE =
  "https://images.unsplash.com/photo-1500534623283-312aade485b7?w=1200&h=630&fit=crop&auto=format&q=80";

/**
 * PageSEO — per-page metadata component.
 * No visual output. Injects title, description, OG, Twitter, and canonical
 * tags into <head> via react-helmet-async.
 *
 * Usage inside any public page:
 *   <PageSEO title="About | Celestial Seed Sanctuary"
 *            description="..."
 *            image="https://..." />
 */
export default function PageSEO({
  title,
  description,
  image = DEFAULT_OG_IMAGE,
  type = "website",
  noindex = false,
}) {
  const { pathname } = useLocation();
  const url = `${PRODUCTION_DOMAIN}${pathname}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Celestial Seed Sanctuary" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
